module.exports = __webpack_public_path__ + "img/education.77b3b8ed.jpg";